import Chart from "@stimulus-components/chartjs"
import {Controller} from "@hotwired/stimulus"
import 'chartjs-adapter-moment';

// Connects to data-controller="monitoring--graph"
export default class extends Chart {
    static targets = ['canvas', 'title', 'period']

    static values = {
        from: String,
        to: String,
        url: String,
        title: String,
        params: String
    };

    connect() {
        super.connect()

        this.updateChart({ detail: { from: this.fromValue, to: this.toValue } });

    }

    async updateChart({detail: {from, to}}) {
        let params = new URLSearchParams()
        params.set('from', from)
        params.set('to', to)
        this.paramsValue = params.toString()
        this.renderGraph()
    }

    async renderGraph() {
        let url =  new URL(this.urlValue);
        let paramsFromUrl = new URLSearchParams(url.search);

        if (paramsFromUrl.size > 0){
            url = `${url}&${this.paramsValue}`
        } else {
            url = `${url}?${this.paramsValue}`
        }

        const req = await fetch(url)
        const result = await req.json()

        if (this.chart) {
            this.titleTarget.innerHTML = result.title

            if (result.scales) {
                this.chart.options.scales = result.scales
            }
            this.chart.data = result.chart
            this.chart.update()
        }
    }

    disconnect() {
        super.disconnect()
    }


}
